import React, { useState } from 'react';
import PropTypes from 'prop-types';

// MUI
import { TextField, styled } from '@mui/material';

// Components
import { GoogleMap, Marker, Autocomplete, useLoadScript } from '@react-google-maps/api';

const MapWrapper = styled('div')`
  & .map-container {
    height: 400px;
  }
  border-radius: 10px;
  overflow: hidden;
`;

const SearchBar = styled(TextField)`
  top: 15px;
  left: 50%;
  width: 90%;
  transform: translateX(-50%);
  background: white;
  border-radius: 10px;
`;

const PositionPicker = ({ position, zoom, ref, setMarkerPosition, markerPosition, setLat, setLng }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: ['places'],
  });
  const [searchValue, setSearchValue] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [center, setCenter] = useState(position);
  const [zoomed, setZoomed] = useState(zoom);

  const handleMarkerClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setMarkerPosition({ lat, lng });
    setLat(lat);
    setLng(lng);
  };

  return isLoaded ? (
    <MapWrapper ref={ref}>
      <GoogleMap
        options={{ disableDefaultUI: true, zoomControl: true, streetViewControl: true }}
        zoom={zoomed}
        center={center}
        mapContainerClassName="map-container"
        onClick={handleMarkerClick}
      >
        <Autocomplete
          onLoad={(autocomplete) => setSearchResult(autocomplete)}
          onPlaceChanged={() => {
            const place = searchResult.getPlace();

            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            setSearchValue(place.formatted_address);
            setMarkerPosition({ lat, lng });
            setLat(lat);
            setLng(lng);

            setCenter({ lat, lng });
            setZoomed(19);
          }}
        >
          <SearchBar
            label="Vyhľadajte adresu"
            variant="outlined"
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            value={searchValue}
          />
        </Autocomplete>
        <Marker position={markerPosition} />
      </GoogleMap>
    </MapWrapper>
  ) : (
    false
  );
};

PositionPicker.propTypes = {
  position: PropTypes.object,
  zoom: PropTypes.number,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  setMarkerPosition: PropTypes.func,
  markerPosition: PropTypes.shape({ lat: PropTypes.number, lng: PropTypes.number }),
  setLat: PropTypes.func,
  setLng: PropTypes.func,
};

PositionPicker.defaultProps = {
  zoom: 7,
};

export default PositionPicker;
